export default "__VITE_ASSET__4VOacABI__"